// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2FNvG","ranges":"BmiRanges_ranges__ALF18"};